import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgComponent() {
    return (
        <Svg
            width={11}
            height={11}
            viewBox="0 0 17 17"
            fill="none"
        >
            <G
                clipPath="url(#clip0_2063_2875)"
                stroke="#9F9F9F"
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            >
                <Path d="M8.5 15.583a7.083 7.083 0 100-14.166 7.083 7.083 0 000 14.166zM8.5 11.333V8.5M8.5 5.667h.008" />
            </G>
            <Defs>
                <ClipPath id="clip0_2063_2875">
                    <Path fill="#fff" d="M0 0H17V17H0z" />
                </ClipPath>
            </Defs>
        </Svg>
    )
}

export default SvgComponent
